module.exports = __webpack_public_path__ + "static/media/carbono.a32881ef.jpg";